import { Instance, SnapshotOut } from 'mobx-state-tree'

import { MessagesModel } from './messages'

/**
 * A MessagesStore model.
 */

export const MessagesStore = MessagesModel.named('MessagesStore')

/**
 * The MessagesStore instance.
 */
export type MessagesStoreType = Instance<typeof MessagesStore>

/**
 * The data of a MessagesStore.
 */
export type MessagesStoreSnapshot = SnapshotOut<typeof MessagesStore>
